/* eslint-disable @typescript-eslint/no-explicit-any */
import BannerAds from '@/components/BannerAds'
import { Suspense } from 'react'

const BannersLayout = ({
  className,
  searchTerm,
  pageType,
  enabledAds,
  adsBanner,
  extraTargeting,
}: any) => {
  return (
    enabledAds && (
      <div className={className}>
        <Suspense fallback="">
          <BannerAds
            shapeSquare
            id={adsBanner.id}
            path={adsBanner.path}
            size={adsBanner.size}
            aspectRatio={adsBanner.aspectRatio}
            pagetype={pageType}
            searchterm={searchTerm}
            showLoad={false}
            extraTargeting={extraTargeting}
          />
        </Suspense>
      </div>
    )
  )
}

export default BannersLayout
